import React, { FC } from 'react';

import {
  textBody,
  textCaption,
} from '../../../../growth-platform-brand-system-v2/src/styles/typography';
import { classNames } from '../../../../growth-platform-brand-system-v2/src/utils/style';
import { IImage } from '../../types/module';
import { Image } from '@payfit/growth-platform-brand-system-v2';

const UPDATED_AT = {
  fr: 'Mise à jour le',
  en: 'Last updated on',
  es: 'Actualizado el',
};

export interface AuthorProps {
  authorImage?: IImage;
  authorName?: string;
  authorPosition?: string;
  locale?: 'fr' | 'en' | 'es';
  updateTime?: Date;
}

const formatDate = (date: Date, locale: string): string => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

export const Author: FC<AuthorProps> = ({
  authorImage,
  authorName,
  authorPosition,
  locale,
  updateTime,
}) => {
  return (
    <div className="Author flex flex-row items-center">
      {authorImage?.url && (
        <Image
          loading="eager"
          alt="hero image"
          className="w-64 h-64 rounded-full overflow-hidden mr-16 min-w-64"
          src={authorImage?.url}
          height={authorImage?.height || 64}
          width={authorImage?.height || 64}
          sizes="64px"
          pixelDensity="image"
        />
      )}

      <div>
        {authorName && <p className={textBody}>{authorName}</p>}
        {authorPosition && (
          <p className={classNames(textCaption, 'text-neutral-101')}>
            {authorPosition}
          </p>
        )}
        {locale !== undefined && updateTime && (
          <p className={classNames(textCaption, 'text-neutral-101')}>{`${
            UPDATED_AT[locale]
          } ${formatDate(updateTime, locale)}`}</p>
        )}
      </div>
    </div>
  );
};
